import React from "react";
import "./apiDocsCard.css";

function ApiDocsCard({ imgSrc, text, onclick }) {
  return (
    <div className="apidocscard-container" onClick={onclick}>
      <img src={imgSrc} alt="" loading="lazy" decoding="async" />
      <span>{text}</span>
    </div>
  );
}

export default React.memo(ApiDocsCard);
